import { createTranslator, type useTranslations } from 'next-intl'
import englishMessages from '@/translations/en/plan-presentation.json'
import { getFIELD_LABELS, getNUMERIC_FIELDS, getSECTIONS, type PlanCatalogTranslator } from './catalog'

export type PlanPresentationTranslator = ReturnType<typeof useTranslations<'PlanPresentation'>>
export interface PlanPresentation {
  t: PlanPresentationTranslator
  locale: string
  sections: ReturnType<typeof getSECTIONS>
  labels: ReturnType<typeof getFIELD_LABELS>
  fields: ReturnType<typeof getNUMERIC_FIELDS>
}

/** Canonical defaults for pure parsing and existing non-UI consumers. */
export const englishPlanPresentation: PlanPresentation = {
  t: createTranslator({ locale: 'en', messages: englishMessages, namespace: 'PlanPresentation' }),
  locale: 'en', sections: getSECTIONS(), labels: getFIELD_LABELS(), fields: getNUMERIC_FIELDS(),
}

export function getPlanPresentation(t: PlanPresentationTranslator, catalog: PlanCatalogTranslator, locale: string): PlanPresentation {
  return { t, locale, sections: getSECTIONS(catalog), labels: getFIELD_LABELS(catalog), fields: getNUMERIC_FIELDS(catalog) }
}

export function formatPlanUnit(unit: string, count: number, { t, locale }: PlanPresentation): string {
  const amount = new Intl.NumberFormat(locale, { maximumFractionDigits: 20, useGrouping: false }).format(count)
  switch (unit) {
    case 'credits': return t('credits', { count, amount })
    case 'credits / month': return t('creditsMonthly', { count, amount })
    case 'days': return t('days', { count, amount })
    case 'hours': return t('hours', { count, amount })
    case 'USD / month': return t('usdMonthly', { count, amount })
    case '× cost': return t('costMultiplier', { count, amount })
    default: return `${amount} ${unit}`
  }
}
